import React, { useMemo } from 'react';
import styled from 'styled-components';
import { theme, toRem } from 'design';
import { Duration as DurationConfig } from 'utils/duration';

interface IDurationProps {
  className?: string;
  disabled?: boolean;
  /**
   * @description duration in seconds
   */
  duration: number;
  label: string;
  onClick?(): void;
}

const DurationLabel = styled.span`
  margin-right: 20px;
  font-family: ${theme.font.family.euclid};
  font-size: ${toRem(12)};
  font-weight: 500;
  color: ${theme.color.neutral[500]};
`;

const DurationLayout = styled.button`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: ${toRem(8)} ${toRem(15)};
  background: ${theme.color.white};
  border: 1px solid ${theme.color.neutral[200]};
  border-radius: ${toRem(100)};

  &:disabled {
    background-color: ${theme.color.neutral[100]};
    cursor: auto;
  }
`;

const DurationValue = styled.span`
  font-size: ${toRem(12)};
  font-weight: 600;
  color: ${theme.color.neutral[900]};
`;

export const Duration: React.FC<IDurationProps> = ({ className = '', label, disabled, duration, onClick }) => {
  const dur = useMemo(() => new DurationConfig(duration), [duration]);
  const durationValue = dur.totalMinutes < 0 ? '--' : dur.toString();

  return (
    <DurationLayout className={className} onClick={onClick} disabled={disabled || !onClick} data-cy="duration-btn">
      <DurationLabel>{label}</DurationLabel>
      <DurationValue>{durationValue}</DurationValue>
    </DurationLayout>
  );
};
